<template>
  <aside class="zsidebar zshowmenu md-hide transparent--bg white">
    
    <w-card 
      class="menutopimg" 
      image="/images/zen.jpeg"
      v-if="0"
    >
      
    </w-card>

    <w-image 
        v-else
        class="menutopimg" 
        
        width="231"
        height="100"
      >
      
      <w-image
        :contain="true"
        class=" d-block"
        src="/images/logow.png" 
        :width="72"
        :height="72">
      </w-image>
      
    </w-image>

    <h1 class="title5 mb3" v-if="0"><w-icon>fal fa-align-justify</w-icon> Menu</h1>

    <z-menu 
    :menu="$page.props.menus"
    />

  </aside>
</template>

<script>

import ZMenu from './Menu'

export default {
  components:{
    ZMenu
  },
  data: () => ({

    loaded: false,
  }),
}
</script>

<style>
.zsidebar {
  min-width: 230px;
  max-width: 230px;
  min-height: 100vh;
  transition: .3s;
  /*border-right: 1px solid #e3ebf6;
  background-image: linear-gradient(to left, #001f59 , #000031);*/
}

.menutopimg {
  /* margin-top: -12px; */
  margin-left: -12px;
  margin-right: -12px;
}

.zshowmenu {
  display: block !important;
}

.zhidemenu {
  /* transition: visibility 0s, opacity 0.5s linear; */
  /* transition: width 2s, width 1s cubic-bezier(0.18, 0.89, 0.32, 1.28); */
  /* display: none; */
  width: 0px;
  max-width: 0px;
  min-width: 0px;
  opacity: 0;
  padding: 0;
}

</style>